import { gql } from '@apollo/client';
import { genericFields } from './index';

export const itemsFragment = gql`
  fragment itemFields on ESItem {
    ${genericFields}
    isBusiness
    photos(limit: 1) {
      thumbnail
      f460x345
    }
  }
`;

export const searchResultItemFragment = gql`
  fragment searchResultItem on ESItem {
    ${genericFields}
    isBusiness
    photos(limit: 1) {
      thumbnail
      f460x345
    }
  }
`;
